import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, IconButton } from '@mui/material';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ProfileContent from './ProfileContent.tsx';
import WebhookContent from './WebhookContent.tsx';
import SettingContent from './SettingContent.tsx';
import DynamicBreadcrumbs from '../../../Shared/Breadcrumb/index.tsx';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router';

const AppDetails: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };
  const breadcrumbLabel = selectedTab === 0 ? 'Pofile' : selectedTab === 1 ? 'Webhook' : "Settings";

  const breadcrumbsData = [
    {
      label: (
        <IconButton color="primary">
          <HomeIcon />
        </IconButton>
      ),
      href: '/',
    },
    { label: 'App List', href: '/r/whatsapp/manager/app-list' },
    { label: breadcrumbLabel},
  ];

  return (
    <Box sx={{ padding: 2, backgroundColor: '#f4f5f7', minHeight: '100%' }}>
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(event, item: { label: string; href: string }) => {
          if (item) {
            navigate(item?.href);
          }
        }}
      />
      {/* Tabs (Replaces Dropdown) */}
      <Box sx={{ marginBottom: 4, borderBottom: '1px solid #ddd' }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Profile" />
          <Tab label="Webhook" />
          {/* <Tab label="Settings" /> */}
        </Tabs>
      </Box>

      {/* Profile Tab */}
      {selectedTab === 0 && <ProfileContent />}

      {/* Webhook Tab */}
      {selectedTab === 1 && <WebhookContent />}

      {/* Setting Tab */}
      {/* {selectedTab === 2 && <SettingContent />} */}
    </Box>
  );
};

export default AppDetails;
